import React from "react";
import Navbar from "../../components/main_page/Navbar";
import { Link } from "react-router-dom";
import { IoArrowBackOutline } from "react-icons/io5";
import { FiExternalLink } from "react-icons/fi";
import { BsGithub } from "react-icons/bs";

import Technologies from "../../components/portfolio/Technologies";
import FullCarousel from "../../components/portfolio/FullCarousel";

import img11 from "../../assets/images/portfolio/PNT-Clothing/admin products.png";
import img10 from "../../assets/images/portfolio/PNT-Clothing/admin-category.png";
import img9 from "../../assets/images/portfolio/PNT-Clothing/admin-stats.png";
import img8 from "../../assets/images/portfolio/PNT-Clothing/admin-users.png";
import img6 from "../../assets/images/portfolio/PNT-Clothing/checkout.png";
import img7 from "../../assets/images/portfolio/PNT-Clothing/history.png";
import img1 from "../../assets/images/portfolio/PNT-Clothing/home.png";
import img2 from "../../assets/images/portfolio/PNT-Clothing/signup.png";
import img5 from "../../assets/images/portfolio/PNT-Clothing/women.png";
import img4 from "../../assets/images/portfolio/PNT-Clothing/shop.png";
import img3 from "../../assets/images/portfolio/PNT-Clothing/login.png";

import demo1 from "../../assets/images/portfolio/PNT-Clothing/demo1.m4v";
import demo2 from "../../assets/images/portfolio/PNT-Clothing/demo2.m4v";
import demo3 from "../../assets/images/portfolio/PNT-Clothing/demo3.m4v";
import demo4 from "../../assets/images/portfolio/PNT-Clothing/demo4.m4v";
import Demo from "../../components/portfolio/Demo";

function Pnt() {
  const technologies = [
    "Code Igniter",
    "Bootstrap",
    "JQuery",
    "REST",
    "MySQL",
    "Postman",
  ];

  const images = [
    img1,
    img2,
    img3,
    img4,
    img5,
    img6,
    img7,
    img8,
    img8,
    img9,
    img10,
    img11,
  ];

  const demos = [demo1, demo2, demo3, demo4];
  return (
    <div className="bg-slate-50 min-h-screen relative flex flex-col items-center">
      <div className="h-20 bg-cool-300 absolute top-0 w-full"></div>

      <div className="relative w-[90%] bg-white z-50 py-40 md:px-10 px-5 drop-shadow-md flex flex-col items-center mt-10 overflow-y-scroll h-[calc(100vh-4rem)]">
        <Link
          to="/portfolio"
          className="bg-cool-300 absolute top-10 left-10 text-white rounded-full w-20 h-20 flex items-center justify-center drop-shadow-md"
        >
          <IoArrowBackOutline size={50} />
        </Link>

        <div className="">
          <h1 className="text-cool-400 font-semibold text-4xl">
            PNT Clothing Store
          </h1>
        </div>

        <div className="w-[80%] mt-10 drop-shadow-md">
          <h2 className="py-5  text-xl">Technologies</h2>
          <div className="flex gap-6 flex-wrap">
            <Technologies technologies={technologies} />
          </div>

          <hr className="my-10"></hr>
          <a
            href="https://github.com/eddiemg10/PNT-Clothing"
            target="_blank"
            className=" text-cool-300 hover:cursor-pointer flex gap-5"
          >
            <BsGithub size={30} />
            <p className="flex items-center">
              <span>Github repository</span> <FiExternalLink className="ml-2" />{" "}
            </p>
          </a>
        </div>
        <div className="mt-20 w-full flex flex-col  items-center justify-center">
          <div className="md:w-[90%] w-full">
            <FullCarousel images={images} />
          </div>
        </div>

        <div className="font-thin text-cool-400 lg:text-xl md:text-lg text-base lg:px-20 md:px-10 px-5 mt-20">
          <p className="my-5">
            PNT Clothing store is an online store I built as an individual
            project that covers fundamental basics of an E-commerce website
            including: User friendly design, Simple product layout with search
            and fileting options, a cart and checkout system.
          </p>

          <p className="my-5">
            {" "}
            This project was made with the Code Igniter 4 framework, using PHP
            for the backend and HTML/CSS for the frontend. Bootstrap CSS was
            used to give the application a modern look and feel while JQuery was
            used to make it more responsive throught DOM manipulation and AJAX
            requests.
          </p>

          <p className="my-5">
            I was also able to build an API which was consumed by the
            application to give it full CRUD functionality. The API was tested
            and documented using Postman.
          </p>
        </div>

        <div className="mt-20 w-full">
          <h1 className="font-semibold text-4xl text-cool-400 text-center">
            System Demo
          </h1>

          <div className="w-full  mt-20">
            <Demo demos={demos} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Pnt;
